import { createResponseTransformer } from "shared/api/createResponseTransformer"

export const noTransform = createResponseTransformer(json => json)
